import { openDB } from 'idb';


const productData =(data, flag,for_newPromotion) => {
    // alert('heloo')
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);

    
        const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },       // eslint-disable-line
         "is_newPromotion")        

 
    }

    saveData(data, flag)
    // if(isSaveDraft===false){
    //   // alert('data')
    // }
    // else{
    
    //   // alert('flag')
    // }
  }

export default class IsChannel {
    
    static ischannel(type,state,props){
        
     const isNew_createPromotion = (type,state,props) => {
        if(type === 'onEmpty') return productData(undefined, true,true)
         const {selectedChannel,selectedMasterChannel,selectedElement,selectedSubElement } = state
        let metadata = props.draftData?.ActivityMetadata?.channel_detail
  if(type === 'master_channel'){
  for(let i=0;i<=selectedMasterChannel.length;i++ ){
    // ToastsStore.warning('false')
    let arr =metadata?.master_channels ? metadata?.master_channels :[]
  if(selectedMasterChannel[i]){
    if(arr.length===0){
     return  productData(undefined, true,true)
    }
    arr.some((cat,cat_index) => {
      // ToastsStore.success("inner filter ")
     return selectedMasterChannel[i]!==cat && productData(undefined, true,true)
    })
  }
  }
 }
  else if(type ===  'channel'){
  for(let i=0;i<=selectedChannel.length;i++ ){
    // ToastsStore.warning('false')
    let arr =metadata?.channels ? metadata?.channels :[]
  if(selectedChannel[i]){
    if(arr.length===0){
      return  productData(undefined, true,true)
     }
    arr.some((cat,cat_index) => {
      // ToastsStore.success("inner filter ")
      return selectedChannel[i]!==cat && productData(undefined, true,true)
    })
  }
  }
  }
   else if(type === 'element'){
  
    for(let i=0;i<=selectedElement.length;i++ ){
      // ToastsStore.warning('false')
      let arr =metadata?.elements ? metadata?.elements :[]
    if(selectedElement[i]){
      if(arr.length===0){
        return  productData(undefined, true,true)
       }
      arr.some((cat,cat_index) => {
        // ToastsStore.success("inner filter ")
        return selectedElement[i]!==cat && productData(undefined, true,true)
      })
    }
    }

  }
   
    else if(type ===  'sub_element'){
    for(let i=0;i<=selectedSubElement.length;i++ ){
      // ToastsStore.warning('false')
      let arr =metadata?.sub_elements ? metadata?.sub_elements :[]
    if(selectedSubElement[i]){
      if(arr.length===0){
        return  productData(undefined, true,true)
       }
      arr.some((cat,cat_index) => {
        // ToastsStore.success("inner filter ")
        return selectedSubElement[i]!==cat && productData(undefined, true,true)
      })
    }
    }
    }

       
     }
      return (
        isNew_createPromotion(type,state,props)
      )
    }
}
// export default IsMetaDataChange = () => {
// }